import React , { useState,useEffect }from 'react'
import { Button,  Form, Input,Checkbox, message } from 'antd';
import { UserOutlined,LockOutlined } from '@ant-design/icons';
import './login.css';
import {reqLogin} from '../../api';
// import { useNavigate } from 'react-router-dom';
// import CryptoJS from 'crypto-js';
import { encrypt,decrypt,localStorageSet,localStorageGet } from '../../utils/global.js';
// import { RabbitLegacy } from 'crypto-js';
import CryptoJs from 'crypto-js';

// const navigate = useNavigate();
  // navigate(-1)//适用于返回上级页面
  // navigate('/router');//也可直接加路径

const scrheight = document.body.clientHeight;

var PathBASE=window.location.href;
console.log('PathBASE -------- ', PathBASE);
    PathBASE = PathBASE.split("#/")[0]; 
console.log('PathBASE -------- ', PathBASE);

const Login =(props)=>{
    const [form] = Form.useForm();
    const [bChecked,setChecked] = useState(false);

    useEffect(() => {
      var localLoginfo = localStorageGet('loginfo_k');
      // console.log('localLoginfo:----------- ', localLoginfo);
      if(localLoginfo){
        var dec = decrypt(localLoginfo);
        if(dec){
          var loginfo_ = JSON.parse(dec);
          // console.log('loginfo_--------------', loginfo_)
          form.setFieldValue('account', loginfo_.account);
          form.setFieldValue('passwd', loginfo_.passwd);
          setChecked(true);
        }
      }
      else{
        setTimeout(()=>{
          form.setFieldValue('account', "");
          form.setFieldValue('passwd', "");
          setChecked(false);

        }, 100)
      }
    }, []);
    
    const onChange = (e) => {
      setChecked(e.target.checked);
    };

    const onFinish = async(value)=>{
        console.log(value);
        console.log(bChecked);
        localStorage.removeItem('token_k');

        if(bChecked){
          localStorageSet("loginfo_k", encrypt(JSON.stringify({"account":value.account, "passwd":value.passwd})));
        }
        else{
          localStorage.removeItem("loginfo_k");
        }
        value.passwd = CryptoJs.MD5(value.passwd).toString();
        reqLogin(value.account,value.passwd).then(response=>{
          const result=response.data
          if(result.code===9){
              message.success('登录成功');
              localStorage.setItem('token_k',result.token);
              localStorageSet("UserInfo_k", {id:result.id, account:result.username, name:result.name, roleid:result.roleid, menus:result.menus});
              console.log('---------登陆成功----------')
              console.log(result)
              console.log('==========mymenus===========', mymenus)
              var goto = "/dashboard";
              if(result.roleid != 99){
                var mymenus = JSON.parse(result.menus);
                if(!mymenus.includes("/dashboard")){
                  if(mymenus.includes("/order"))
                    goto = "/order";
                  else
                    goto = mymenus[0];
                }
              }
              window.location.href=PathBASE+'#'+goto;
              // var myDate = new Date();
             
              // localStorage.setItem('UserInfo',JSON.stringify(result));
              // localStorage.setItem('LoginTime',myDate);
              // // 不需要回退操作用replace，需要用push
              // let home = result.menus[0]?result.menus[0]:'/'
              // console.log(home)
              // this.props.history.replace(home); 
          }else if(result.code===0){
              message.error('用户名不存在')
              // this.props.history.push('/'); 
          }else{
              message.error(result.msg)
          }
      }).catch(error=>{
          console.log(error)
      })
        // try {
        //     return await getApiData('A', 'A_login', value).then((res) => {
        //       console.log('A_login-res-----------------', res);
        //       var flag = checkLogin('A', res.data)
        //       if (flag) {
        //         localStorage.setItem('token',res.data.d.token);
        //         localStorageSet("UserInfo", {id:res.data.d.uid, account:value.account});
        //         window.location.href='/#/order';
        //         // props.history.push({
        //         //     pathname: '/admin',
        //         //   });
        //       }
        //     });
        //   } catch (error) {
            
        //     return false;
        //   }
    }
  return (
    <div className='loginbg' style={{height:"100vh", display:"flex", justifyContent:"center", alignItems:"center"}}>
    <div  id="box" className='container' style={{maxWidth:400}} >
        <div style={{background:"white",boxShadow:" 0 0 10px rgba(0, 0, 0, 0.1)", borderRadius:3, overflow:'hidden',padding:"30px 5px 10px"}}>
          <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
            <img src={[require("../../img/logo1.png")]} alt="" width="70%" style={{color:"rgb(80,135,197)"}} />
            {/* <span style={{fontSize:30, fontWeight:600, color:"rgb(21,72,152)", marginLeft:15}}>快盘科技</span> */}
          </div>
            <Form form={form}
            className='loginForm'
            name="normal_login"
            // labelCol={{span: 5}}
            // wrapperCol={{span: 16}}
            onFinish={onFinish}
            layout="vertical"
            // onFinishFailed={this.onFinishFailed}
            autoComplete="off"
        >
            <Form.Item
                // label="账号"
                name="account"
                // className='normal_input'
                rules={[
                  {required: true, message: '请输入邮箱/手机号',},
                  // {pattern: /^1\d{10}$/, message: '手机号格式错误'},

                  // {max: 12,message: '用户名最多12位',},
                  // {min: 3,message: '用户名至少3位',},
                  // {pattern:/^[a-zA-Z0-9_]+$/,message: '用户名必须是英文、字母或下划线',},

                    // {
                    // required: true,
                    // message: '请输入您的手机号！',
                    // },
                ]}
            >
            <Input placeholder="邮箱/手机号" addonBefore={<UserOutlined />} />
            </Form.Item>
            <Form.Item
                // label="密码"
                name="passwd"
                rules={[
                  {required: true,message: '密码必须6-30个字符',},
                  {max: 30,message: '密码最多30位',},
                  {min: 6,message: '密码至少6位',},
                  // {pattern:^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$,message: '密码必须包含字母和数字',},
                ]}
            >
            <Input.Password  placeholder="密码" addonBefore={<LockOutlined />} />
            </Form.Item>
            <Form.Item name="bChecked" style={{textAlign:"left"}}>
            <Checkbox checked={bChecked} onChange={onChange}>记住我</Checkbox>
            </Form.Item>
            <Form.Item>
            <div>
            <Button type="primary" htmlType="submit" style={{width: "100%",height:35,borderRadius: 1,backgroundColor: "rgb(21,72,152)",borderColor: "rgb(21,72,152)",fontSize: 15,marginTop:-10}}>
                登录
            </Button>
            </div>
            </Form.Item>
        </Form>
        </div>
        </div>
    </div>
  )
}
export default Login
